import { useState, useEffect } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { MobileSidebarTrigger } from "@/components/MobileSidebarTrigger";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { TrialProtectedRoute } from "./TrialProtectedRoute";
import { TrialBanner } from "./TrialBanner";
import { SyncIndicator } from "./SyncIndicator";
import { AlertasFinanceiros } from "./AlertasFinanceiros";
import { ConcurrencyAlert } from "./ConcurrencyAlert";
import { TermsAcceptanceModal } from "./TermsAcceptanceModal";
import { useTermsAcceptance } from "@/hooks/useTermsAcceptance";
import { useIsMobile } from "@/hooks/use-mobile";

export function Layout() {
  const { user, loading } = useAuth();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const { needsAcceptance, loading: termsLoading, refreshAcceptance } = useTermsAcceptance();
  const [termsAcceptedRecently, setTermsAcceptedRecently] = useState(false);

  // Atualizar estado do sidebar quando mudar de mobile para desktop
  useEffect(() => {
    console.log("📱 Layout - isMobile:", isMobile, "sidebarOpen:", sidebarOpen);
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  // ✅ PROTEÇÃO: Se aceitou os termos recentemente, não mostrar modal novamente por 5 segundos
  const handleTermsAccepted = () => {
    console.log('🎉 Termos aceitos - bloqueando nova verificação por 5s');
    setTermsAcceptedRecently(true);
    refreshAcceptance();
    
    // Após 5 segundos, permitir verificação novamente se necessário
    setTimeout(() => {
      setTermsAcceptedRecently(false);
    }, 5000);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-purple-600 font-medium">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SidebarProvider 
      defaultOpen={sidebarOpen}
      onOpenChange={(open) => {
        console.log("🔄 SidebarProvider onOpenChange:", open);
        setSidebarOpen(open);
      }}
    >
      <TrialProtectedRoute>
        <div className="min-h-screen flex w-full bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100 relative">
          <AppSidebar />
          
          {/* Alerta de concorrência */}
          <ConcurrencyAlert />
          
          <main className="flex-1 overflow-auto">
            {/* Header mobile */}
            <div className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200/50 p-3 md:hidden flex items-center justify-between">
              <MobileSidebarTrigger />
              <div className="text-sm text-gray-600 font-medium">
                Ateliê PRO
              </div>
              <div className="flex items-center gap-2">
                <AlertasFinanceiros />
                <SyncIndicator />
              </div>
            </div>

            {/* Outlet com conteúdo */}
            <Outlet />
          </main>
        </div>
      </TrialProtectedRoute>

      {/* Modal de aceite de termos - DESATIVADO */}
      {/* <TermsAcceptanceModal
        isOpen={needsAcceptance === true && !termsLoading && !termsAcceptedRecently}
        onAccept={handleTermsAccepted}
      /> */}
    </SidebarProvider>
  );
}
